import LoadingPage, {Loading} from './loading';


export default LoadingPage;
export {Loading};
